<template>
  <div id="admin-exam-edit">
    <!-- 考试编辑界面 -->
    <div class="content" v-loading="loading">
      <div class="goback" @click="goback">
        <i class="el-icon-d-arrow-left"></i>返回
      </div>
      <div class="con">
        <div
          :class="{ line: true, 'line-half': !item.ishe }"
          v-for="(item, index) in data"
          :key="index"
        >
          <div class="title">
            <span v-if="item.title != ''"
              ><span v-if="item.isNotNull" class="xx">*</span
              >{{ item.title }}:</span
            >
          </div>
          <div class="value" v-if="item.type == 'input'">
            <el-input
              v-model="item.value"
              :placeholder="'请输入' + item.title"
              clearable
            ></el-input>
          </div>
          <div class="value" v-if="item.type == 'time'">
            <el-date-picker
              v-model="item.value"
              type="datetime"
              :placeholder="'选择' + item.title"
              :min-date="currentDate"
              :picker-options="pickerOptions"
              value-format="yyyy-MM-dd HH:mm:ss"
            >
            </el-date-picker>
          </div>
          <div class="value" v-if="item.type == 'select'">
            <el-select
              v-model="item.value"
              :placeholder="'请选择' + item.title"
              clearable
              filterable
            >
              <el-option
                v-for="it in item.option"
                :key="it.id"
                :label="it.name"
                :value="it.id"
              >
              </el-option>
            </el-select>
          </div>
          <div class="value" v-if="item.type == 'selects'">
            <el-select
              v-model="item.value"
              :placeholder="'请选择' + item.title"
              multiple
              clearable
              filterable
            >
              <el-option
                v-for="it in item.option"
                :key="it.id"
                :label="it.name"
                :value="it.id"
              >
              </el-option>
            </el-select>
          </div>
          <div class="value" v-if="item.type == 'radio'">
            <el-radio-group v-model="item.value">
              <el-radio
                v-for="(it, ii) in item.option"
                :key="ii"
                :label="it.value"
                >{{ it.label }}</el-radio
              >
            </el-radio-group>
          </div>
          <div class="value" v-if="item.type == 'radio-event'">
            <el-radio-group v-model="item.value">
              <el-radio
                v-for="(it, ii) in item.option"
                :key="ii"
                :label="it.value"
                >{{ it.label }}</el-radio
              >
            </el-radio-group>
          </div>
          <div class="tt" style="margin-left: 20px">{{ item.tip }}</div>
        </div>
        <div class="line">
          <div class="title"><span class="xx">*</span>考场:</div>
          <div class="value kc">
            <div
              class="va"
              v-for="(item, index) in examinationRoom"
              :key="index"
            >
              <div class="ti">考场号:</div>
              <div class="vaa">
                <el-input
                  v-model="item.room"
                  placeholder="请输入考场号"
                ></el-input>
              </div>
              <div class="ti">最大容纳人数(人):</div>
              <div class="vaa">
                <el-input
                  v-model="item.num"
                  placeholder="请输入最大容纳人数"
                ></el-input>
              </div>
              <i
                class="el-icon-circle-plus-outline"
                @click="editRoom(index, 0)"
              ></i>
              <i
                class="el-icon-remove-outline"
                v-if="index > 0"
                @click="editRoom(index, 1)"
              ></i>
            </div>
          </div>
        </div>
        <div class="line">
          <div class="title">考场排号:</div>
          <div class="value">
            <div class="add_but" @click="rowNumber(1)">考试排号</div>
            <div class="add_but" @click="rowNumber(2)">查看排号</div>
            <div class="add_but" @click="rowNumber(3)">排号导出</div>
          </div>
        </div>
        <div class="line">
          <div class="title"></div>
          <div class="add_but" @click="submit">
            <i class="el-icon-check"></i> 提交
          </div>
        </div>
      </div>
    </div>

    <diy_dialog
      v-if="dialogData.flag"
      :title="dialogData.title"
      :width="dialogData.width"
      :dialogData="dialogData.dialogData"
      :buttonList="dialogData.buttonList"
      @colseDialog="colseDialog"
      @dialogOper="dialogOper"
    ></diy_dialog>
  </div>
</template>

<script>
import * as examData from "./js/exam.js";
export default {
  data() {
    return {
      loading: true,
      currentDate: new Date(),
      pickerOptions: {
        disabledDate(time) {
          // 禁用小于当前日期的时间
          return time.getTime() < Date.now() - 8.64e7;
        },
      },
      id: "",
      data: examData.getExamEditPageData(),
      taskType: "0", //是否关联任务
      teachrOptions: [],
      optionData: {
        department: [],
        professional: [],
        testPaperId: [],
        spare: [],
        teacher: [],
        readOver: [],
      },
      examinationRoom: [{ room: "", num: "" }], // 考场号
      associatedTask: "",
      departmentList: [], // 所有部门
      professionalList: [], // 所有专业
      userList: [], // 所有用户
      paperList: [], // 所有试卷
      dialogData: {
        flag: false,
        title: "添加子部门",
        width: "50%",
        tempData: {},
        dialogData: [],
        buttonList: [
          { text: "确定", active: "makesure_add_child_dep" },
          { text: "取消", active: "cancel" },
        ],
      },
    };
  },
  methods: {
    /**
     * 获取基本数据
     * 部门  专业  人员  试卷
     */
    async getPageBaseData() {
      try {
        // 获取所有部门
        let departRequest = await this.$request({
          url: "/department/getDepartmentList",
          method: "post",
          data: { name: "" },
        });
        this.optionData.department = departRequest;
        // // 获取所有专业
        let professionRequest = await this.$request({
          url: "/professional/getProfessionalList",
          method: "post",
          data: { name: "" },
        });
        this.optionData.professional = professionRequest;
        // 所有用户
        let userRequest = await this.$request({
          url: "/user/getUserDropList",
          method: "post",
          data: null,
        });
        this.optionData.teacher = userRequest;
        this.optionData.readOver = userRequest;
        // 所有试卷
        let paperRequest = await this.$request({
          url: "/testPaper/getAllTestPaperDropList",
          method: "post",
          data: { name: "" },
        });
        this.optionData.testPaperId = paperRequest;
        this.optionData.spare = paperRequest;

        // 将option数据渲染到界面
        this.data.forEach((element) => {
          if (this.optionData[element.key] != null) {
            element.option = this.optionData[element.key];
          }
        });
      } catch (error) {
        this.$message.error(error.message);
      }
    },
    /**
     * 初始化界面数据
     ID 不为空时,即为编辑考试,初始化时,获取考试详情
     */
    async initData() {
      try {
        if (this.id != "") {
          let resultData = await this.$request({
            url: "/exam/showExamDetails",
            method: "post",
            data: { id: this.id },
          });
          this.data = this.$baseData.json2array(this.data, resultData);
          this.examinationRoom = resultData.examRoom;
        }
        this.loading = false;
      } catch (error) {
        this.$message.error(error.message);
        this.loading = false;
      }
    },
    /**
     * 开始/查看排号
     * 若当前操作为添加操作,排号前,调用保存接口,且此时创建的数据的delete为1
     */
    async rowNumber(flag) {
      try {
        let requestData = {};
        switch (flag) {
          case 1:
            // 排号
            this.data.forEach((element) => {
              if (
                element.isNotNull &&
                (element.value == "" || element.value.length == 0)
              ) {
                throw { message: element.title + "不可为空!" };
              }
            });
            let text = this.judgeExamRoom();
            if (text != "0") {
              throw { message: text };
            }
            if (!isNaN(requestData.examDuration)) {
              throw { message: "考试时长只能为数字!" };
            }
            // 2. 选择排号方式
            this.dialogData.title = "选择排号方式";
            requestData = this.$baseData.array2json(this.data, requestData);
            let department = requestData.department;
            let professional = requestData.professional;
            this.dialogData.dialogData = [
              {
                type: "choose-row-num",
                value: { type: "0", userList: [] },
                department: department,
                professional: professional,
              },
            ];
            this.dialogData.buttonList = [
              { text: "确定", active: "makesure-choose-row" },
              { text: "取消", active: "cancel" },
            ];
            this.dialogData.flag = true;
            break;
          case 2:
            // 查看
            if (this.id == "") {
              throw { message: "请先进行考试排号操作!" };
            }
            let resultData = await this.$request({
              url: "/examPlan/showExamPlan",
              method: "post",
              data: { id: this.id }, // 考试ID,
            });
            if (resultData.length == 0) {
              // 之前没有生成安排
              throw { message: "请先进行考试排号操作!" };
            }
            this.$router.push({
              path: "/admin/exam-index/row_number",
              query: {
                id: this.id,
                flag: "1", // 0 初始化界面时为调用排号接口,  1 为初始化界面时直接查看排号
              },
            });
            break;
          case 3:
            // 导出排号
            if (this.id == "") {
              throw { message: "请先进行考试排号操作!" };
            }
            this.$requestForReport(
              "post",
              "/examPlan/exportSeat",
              { id: this.id },
              (data) => {
                let blob = new Blob([data], {
                  type: "application/force-download",
                }); // Blob 对象表示一个不可变、原始数据的类文件对象
                console.log(blob);
                let fileReader = new FileReader(); // FileReader 对象允许Web应用程序异步读取存储在用户计算机上的文件的内容
                fileReader.readAsDataURL(blob);
                //开始读取指定的Blob中的内容。一旦完成，result属性中将包含一个data: URL格式的Base64字符串以表示所读取文件的内容
                fileReader.onload = (e) => {
                  let a = document.createElement("a");
                  a.download = `考试计划表.xls`;
                  a.href = e.target.result;
                  document.body.appendChild(a);
                  a.click();
                  document.body.removeChild(a);
                };

                this.$message({
                  type: "success",
                  message: "导出成功!",
                  duration: 1000,
                });
              }
            );
            break;

          default:
            break;
        }
      } catch (error) {
        this.$message.error(error.message);
      }
    },

    /**
     * 弹出框操作事件
     */
    async dialogOper(active) {
      try {
        switch (active) {
          case "makesure-choose-row":
            // 确定排号方式
            let flag = await this.saveExam("1"); // 是否保存成功
            if (flag) {
              setTimeout(() => {
                let userList = this.dialogData.dialogData[0].value.userList;
                let list = [];
                userList.forEach((element) => {
                  if (element.flag) {
                    list.push(element);
                  }
                });
                console.log(list);
                sessionStorage.setItem("userList", JSON.stringify(list));
                sessionStorage.setItem(
                  "examRoom",
                  JSON.stringify(this.examinationRoom)
                );
                this.$router.push({
                  path: "/admin/exam-index/row_number",
                  query: {
                    id: this.id,
                    flag: "0", // 0 初始化界面时为调用排号接口,  1 为初始化界面时直接查看排号
                  },
                });
              }, 500);
            }
            break;
          case "cancel":
            this.colseDialog();
            break;

          default:
            break;
        }
      } catch (error) {
        this.$message.error(error.message);
      }
    },
    /**
     * 添加或移除考场号
     * flag:0 添加  1 移除
     * index:索引
     */
    editRoom(index, flag) {
      switch (flag) {
        case 0:
          // 添加
          // 判断之前的考场号与最大容纳人数是否不可为空
          let text = this.judgeExamRoom();
          if (text == "0") {
            let dd = {
              room: "",
              num: "",
            };
            this.examinationRoom.push(dd);
          } else {
            this.$message.warning(text);
          }
          break;
        case 1:
          // 移除
          this.examinationRoom.splice(index, 1);
          break;

        default:
          break;
      }
    },
    /**
     * 判断考场号与最大容纳人数不可为空
     */
    judgeExamRoom() {
      try {
        this.examinationRoom.forEach((element) => {
          if (element.room == "" || element.num == "") {
            throw "非空";
          }
          if (isNaN(element.num)) {
            throw "非数字";
          }
        });
        return "0";
      } catch (error) {
        if (error == "非空") {
          return "请先填充考场号或最大容纳人数!";
        } else {
          return "人数只能为数字!";
        }
      }
    },
    /**
     * 保存
     * 返回保存成功与否
     */
    async saveExam(flag) {
      try {
        let requestData = {
          id: this.id,
          examRoom: this.examinationRoom,
          flag: flag, // 1 创建delete为1的   2 正常保存
        };
        this.data.forEach((element) => {
          if (
            element.isNotNull &&
            (element.value == "" || element.value.length == 0)
          ) {
            throw { message: element.title + "不可为空!" };
          }
        });
        let text = this.judgeExamRoom();
        if (text != "0") {
          throw { message: text };
        }
        if (!isNaN(requestData.examDuration)) {
          throw { message: "考试时长只能为数字!" };
        }
        requestData = this.$baseData.array2json(this.data, requestData);
        let resultData = await this.$request({
          url: "/exam/saveOrUpdateExam",
          method: "post",
          data: requestData,
        });
        this.id = resultData.id;
        sessionStorage.setItem("eaxmId", this.id);
        return true;
      } catch (error) {
        this.$message.error(error.message);
        return false;
      }
    },
    /**
     * 提交
     */
    async submit() {
      let flag = await this.saveExam("0");
      if (flag) {
        this.$router.back();
      }
    },
    /**
     * 返回上一页
     */
    goback() {
      this.$confirm(
        "离开页面会丢失当前编辑的内容,是否保存当前编辑的内容?",
        "您即将离开编辑页面",
        {
          confirmButtonText: "保存",
          cancelButtonText: "返回",
          type: "warning",
        }
      )
        .then(async () => {
          // 保存
          let flag = await this.saveExam("0");
          if (flag) {
            this.$router.back();
          }
        })
        .catch(() => {
          this.$router.back();
        });
    },
    /**
     * 弹出框关闭事件
     */
    colseDialog() {
      this.dialogData.flag = false;
    },
  },
  async mounted() {
    let eaxmId = sessionStorage.getItem("eaxmId");
    if (eaxmId != null) {
      this.id = eaxmId;
    } else {
      this.id = this.$route.query.id;
    }
    sessionStorage.setItem("eaxmId", this.id); // 防止从排号界面回跳至该界面时,路由ID不存在
    await this.getPageBaseData();
    await this.initData();
    sessionStorage.removeItem("userList");
    sessionStorage.removeItem("examRoom");
  },
};
</script>

<style lang="less" scoped>
#admin-exam-edit {
  width: 100%;
  height: 100%;
  display: flex;
  padding: 10px 15px;
  box-sizing: border-box;
  > .content {
    width: 100%;
    height: 100%;
    background-color: #fff;
    display: flex;
    flex-direction: column;
    overflow-y: auto;
    > .con {
      width: 100%;
      height: auto;
      display: flex;
      flex-wrap: wrap;
      align-content: flex-start;
      overflow-y: auto;
    }
    .line {
      width: 100%;
      min-height: 45px;
      display: flex;
      margin-bottom: 15px;
      padding-right: 30px;
      box-sizing: border-box;
      .title {
        width: 180px;
        line-height: 35px;
        text-align: center;
        display: flex;
        align-items: flex-start;
        justify-content: flex-end;
        font-size: 145x;
        font-weight: bold;
        margin-right: 10px;
      }
      .value {
        width: 0;
        flex: 1;
        height: auto;
        display: flex;
        align-items: flex-start;
        justify-content: flex-start;
        /deep/ .el-input__inner,
        .el-radio-group {
          height: 35px;
        }
        /deep/ .el-select .el-input .el-select__caret,
        .el-radio-group,
        .el-input__icon {
          display: flex;
          align-items: center;
        }
        /deep/ .el-date-editor.el-input,
        .el-date-editor.el-input__inner,
        .el-select {
          width: 100%;
        }
        /deep/.el-date-picker {
          width: auto;
        }
      }
    }
    .line-half {
      width: 50%;
      display: flex;
      > .tt {
        margin-left: 20px;
        display: flex;
        align-items: center;
        line-height: 35px;
        text-align: center;
        justify-content: flex-start;
      }
    }
    .kc {
      flex-direction: column;
      > .va {
        width: 100%;
        height: 35px;
        display: flex;
        font-size: 15px;
        align-items: center;
        margin-bottom: 10px;
        > .ti {
          margin: 0 10px;
        }
        i {
          font-size: 20px;
          margin-left: 15px;
          cursor: pointer;
        }
      }
    }
  }

  .xx {
    color: #f00;
    font-size: 20px;
    margin-top: 4px;
    margin-right: 8px;
  }
}
</style>